<template>
  <div>
    <drawer :app="app" />
    <v-container class="mt-1">
      <v-card raised>
        <v-card-title>
          <div>
            {{ $t("labels.MortgageRequest") }} -
            <span
              v-if="isPropertyFound || isPropertyNotFound"
              v-html="$t('labels.Purchase')"
            />
            <span v-if="isRefinance" v-html="$t('labels.Refinance')" />
            <span v-if="isRenewal" v-html="$t('labels.Renewal')" />
            <span
              v-if="isConstruction"
              v-html="$t('labels.ConstructionRefinancing')"
            />
          </div>
        </v-card-title>

        <div style="margin: 1px 5px 5px 15px" v-if="mainApplicant">
          <div class="px-3">
            <v-row
              ><v-col>
                <p>
                  <span v-html="reVisitInterViewDesc" />
                  <b
                    ><router-link
                      :to="
                        '/' +
                        this.siteID +
                        '/user/' +
                        this.mortgageApplicationID +
                        '/start'
                      "
                      link
                    >
                      {{ $t("labels.here") }}</router-link
                    ></b
                  >
                  {{ $t("labels.ToReVisitInterViewSection") }}
                </p>
              </v-col>
            </v-row>

            <!-- Property Found -->
            <template v-if="isPropertyFound">
              <v-row dense>
                <v-col cols="12">
                  <div class="subtitle-1">
                    <b>{{ $t("labels.RequestedMortgage") }}</b
                    ><v-divider />
                  </div>
                </v-col>
                <v-col cols="12">
                  <table>
                    <tr>
                      <td width="250">
                        {{ $t("labels.PurchasePriceProperty") }}
                        <font color="red">*</font>
                      </td>

                      <td width="300" class="pt-10">
                        <VueSlideBar
                          class="ml-3"
                          @input="pvChange"
                          :min="0"
                          :max="5000000"
                          :range="sliderData.range"
                          v-model="app.InterView.PropertyValue"
                        >
                          <template slot="tooltip">
                            <div
                              class="vue-slide-bar-always vue-slide-bar-tooltip-container"
                              style="
                                width: 20px;
                                transition-duration: 0s;
                                transform: translatey(20px);
                              "
                            >
                              <span
                                class="vue-slide-bar-tooltip-top vue-slide-bar-tooltip-wrap"
                                ><span class="vue-slide-bar-tooltip">
                                  {{ app.InterView.PropertyValue | currency }}
                                </span></span
                              >
                            </div>
                          </template>
                        </VueSlideBar>
                      </td>
                      <td class="pl-7" width="180">
                        <v-currency-field
                          prefix="$"
                          v-model.lazy="app.InterView.PropertyValue"
                        ></v-currency-field>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ $t("labels.DownPayment") }}
                        <font color="red">*</font>
                      </td>
                      <td class="pt-10">
                        <VueSlideBar
                          @input="dpChange"
                          class="ml-3"
                          :range="downpaymentData.range"
                          :min="0"
                          :max="100"
                          v-model="dpPercentage"
                        >
                          <template slot="tooltip">
                            <div
                              class="vue-slide-bar-always vue-slide-bar-tooltip-container"
                              style="
                                width: 20px;
                                transition-duration: 0s;
                                transform: translatey(20px);
                              "
                            >
                              <span
                                class="vue-slide-bar-tooltip-top vue-slide-bar-tooltip-wrap"
                                ><span class="vue-slide-bar-tooltip">
                                  {{ dpPercentage + "%" }}
                                </span></span
                              >
                            </div>
                          </template>
                        </VueSlideBar>
                      </td>
                      <td class="pl-7">
                        <v-currency-field
                          prefix="$"
                          v-model="app.InterView.DownPaymentAmount"
                        ></v-currency-field>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          class="mt-4"
                          v-html="$t('labels.RequiredMortgageAmount')"
                        ></div>
                      </td>
                      <td class="text-left">
                        <div class="mt-4">
                          {{ requestedAmount | currency }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </v-col>

                <v-col cols="12" class="mt-10">
                  <div class="subtitle-1">
                    <b>{{ $t("labels.PropertyInformation") }}</b
                    ><v-divider />
                  </div>
                  <div class="mt-4">
                    {{ $t("labels.PropertyAddress") }}
                    <font color="red">*</font>
                  </div>
                  <p_addr
                    v-model="frm.SubjectProperty.Address"
                    :easyModeFlag="true"
                  />
                </v-col>

                <v-col cols="12">
                  <p_property :app="app" :frm="frm" :refinanceFlag="false" />
                </v-col>
              </v-row>
            </template>
            <!-- Property Not Found -->
            <template v-if="isPropertyNotFound">
              <v-row dense>
                <v-col cols="12">
                  <table>
                    <tr
                      v-if="
                        this.app.InterView.SearchStageDD < 4 ||
                        this.app.InterView.DealPurposeDD == 4 ||
                        this.app.InterView.DealPurposeDD == 2 ||
                        this.app.InterView.DealPurposeDD == 3
                      "
                    >
                      <td
                        width="259"
                        v-html="$t('labels.EstimatedClosingDateR')"
                      ></td>
                      <td>
                        <comdatey
                          :label="$t('labels.ClosingDateR')"
                          v-model="frm.SubjectProperty.ClosingDate"
                          :max="date2Years"
                        />
                      </td>
                    </tr>
                    <tr v-else>
                      <td
                        width="259"
                        v-html="$t('labels.EstimatedClosingDate')"
                      ></td>
                      <td>
                        <comdatey
                          :label="$t('labels.MTG_ClosingDate')"
                          v-model="frm.SubjectProperty.ClosingDate"
                          :max="date2Years"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td v-html="$t('labels.WhichProvinceR')"></td>
                      <td width="300">
                        <p_dd
                          menu="Province"
                          v-model="frm.SubjectProperty.Address.ProvinceDD"
                          :label="$t('labels.Province')"
                        />
                      </td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </template>
            <!-- Property Searching -->
            <template v-if="isRefinance || isRenewal">
              <v-row dense>
                <v-col cols="12">
                  <table>
                    <tr>
                      <td width="250">
                        {{ $t("labels.MortgageAmountRequired") }}
                        <font color="red">*</font>
                      </td>
                      <td width="300" class="pt-10">
                        <VueSlideBar
                          class="ml-3"
                          :min="0"
                          :max="5000000"
                          :range="refinanceData.range"
                          v-model="frm.RequestedMortgageAmount"
                        >
                          <template slot="tooltip">
                            <div
                              class="vue-slide-bar-always vue-slide-bar-tooltip-container"
                              style="
                                width: 20px;
                                transition-duration: 0s;
                                transform: translatey(20px);
                              "
                            >
                              <span
                                class="vue-slide-bar-tooltip-top vue-slide-bar-tooltip-wrap"
                                ><span class="vue-slide-bar-tooltip">
                                  {{ frm.RequestedMortgageAmount | currency }}
                                </span></span
                              >
                            </div>
                          </template>
                        </VueSlideBar>
                      </td>
                      <td class="pl-7" width="180">
                        <v-currency-field
                          prefix="$"
                          v-model.lazy="frm.RequestedMortgageAmount"
                        ></v-currency-field>
                      </td>
                    </tr>
                  </table>
                </v-col>

                <v-col cols="12">
                  <div class="subtitle-1">
                    <b>{{ $t("labels.PropertyInformation") }}</b
                    ><v-divider />
                  </div>
                  <div class="mt-4">
                    {{ $t("labels.PropertyAddress") }}
                    <font color="red">*</font>
                  </div>
                  <p_addr
                    v-model="frm.SubjectProperty.Address"
                    :easyModeFlag="true"
                  />
                </v-col>

                <v-col cols="12">
                  <p_property :app="app" :frm="frm" :refinanceFlag="true" />
                </v-col>

                <v-col cols="12">
                  <div class="subtitle-1">
                    <b>{{ $t("labels.ExistingMortgage") }}</b
                    ><v-divider />
                  </div>                
                  <v-card
                    v-for="(mtg, idx) in frm.SubjectProperty.Mortgages"
                    v-bind:key="mtg.MortgageID"
                    outlined
                    class="mb-3"
                  >
                    <v-card-title style="font-size: 16px"
                      >{{ $t("labels.Mortgage") }} {{ idx + 1 }}<v-spacer />
                      <a link @click="deleteMortgage(mtg.MortgageID)"
                        ><v-icon color="red">fas fa-trash-alt</v-icon></a
                      >
                    </v-card-title>
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="12" md="3">
                          <v-select                           
                            v-model="mtg.TypeofMortgage"
                            :items="MortgageTypeItems"
                            item-text="Label"
                            item-value="Value"
                          >
                            <template slot="label">
                              <span v-html="$t('labels.MortgageType')" />
                            </template>
                          </v-select>
                          <!-- <p_dd :dis="true" menu="MortgageType" v-model="mtg.MortgageTypeDD" :label="$t('labels.MortgageType')" /> -->
                        </v-col>
                        <v-col cols="12" md="3">
                          <p_money
                            v-model="mtg.TotalLoanAmount"
                            :label="$t('labels.OriginalMtgAmountR')"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <p_money
                            v-model="mtg.Balance"
                            :label="$t('labels.BalanceR')"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <p_money
                            v-model="mtg.PAndIPayment"
                            :label="$t('labels.PaymentR')"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <p_dd
                            menu="PaymentFrequency"
                            v-model="mtg.PaymentFrequencyDD"
                            :label="$t('labels.PaymentFrequency')"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <comdatey
                            :label="$t('labels.MaturityDate')"
                            v-model="mtg.MaturityDate"
                            :max="date30Years"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <p_dd
                            menu="InterestType"
                            v-model="mtg.RateTypeDD"
                            :label="$t('labels.RateType')"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <p_dd
                            menu="TermType"
                            v-model="mtg.TermTypeDD"
                            :label="$t('labels.TermType')"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="mtg.MortgageHolder"
                            :label="$t('labels.Lender')"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            type="number"
                            suffix="%"
                            v-model="mtg.InterestRate"
                          >
                            <template slot="label">
                              <span v-html="$t('labels.InterestRate')" />
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="3">
                          <p_dd
                            menu="LoanType"
                            v-model="mtg.LoanTypeDD"
                            :label="$t('labels.LoanType')"
                          />
                        </v-col>

                        <v-col cols="12" md="3">
                          <v-switch
                            color="primary"
                            v-model="mtg.MIFlag"
                            :true-value="true"
                            :false-value="false"
                            :label="$t('labels.MortgageInsured')"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row v-if="frm.SubjectProperty.Mortgages.length < 2">
                <v-col cols="12" class="mt-3">
                  <v-btn color="primary" @click="addMortgage">{{
                    $t("labels.AddMortgage")
                  }}</v-btn>
                </v-col>
              </v-row>
            </template>

            <template v-if="isConstruction">
              <v-row dense>
                <v-col cols="12">
                  <div class="subtitle-1">
                    <b>{{ $t("labels.PropertyInformation") }}</b
                    ><v-divider />
                  </div>
                  <div class="mt-4">
                    {{ $t("labels.PropertyAddress") }}
                    <font color="red">*</font>
                  </div>
                  <p_addr
                    v-model="frm.SubjectProperty.Address"
                    :easyModeFlag="true"
                  />
                </v-col>
              </v-row>
            </template>
          </div>

          <v-card-actions class="mb-5 mt-10">
            <v-spacer />
            <v-btn @click="next" color="primary">{{ $t("labels.Next") }}</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
/*
app.InterView.DealPurposeDD
4: Renewing
2: Refinance
0: purchase
app.InterView.SearchStageDD
1: offer accepted
2: placed offer
3: found no offer
4: searching
5: not search
*/
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
//import p_dd from "@/shared/components/ddSelect";
import p_addr from "@/shared/components/addr";
import comdatey from "@/shared/components/datePickerY";
import p_property from "./propertyDetails";
import p_money from "@/shared/components/money";
import p_dd from "@/shared/components/ddSelect";

export default {
  components: {
    drawer,
    p_money,
    comdatey,
    p_dd,
    p_addr,
    p_property,
  },
  computed: {
    date30Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() + 30);
      return n.toISOString().substr(0, 10);
    },
    date2Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() + 2);
      return n.toISOString().substr(0, 10);
    },
    reVisitInterViewDesc() {
      if (this.isPropertyFound) {
        let temp = this.$t("labels.ReVisitPropertyFoundDesc");
        temp = temp.replace("{0}", this.mainApplicant.Identification.FirstName);
        temp = temp.replace("{1}", this.app.InterView.strClosingDateMMM);
        temp = temp.replace("{2}", this.app.InterView.strPropertyValue);
        temp = temp.replace("{3}", this.app.InterView.strDownPaymentAmount);
        temp = temp.replace("{4}", this.app.InterView.strOccupancy);
        return temp;
      }
      if (this.isPropertyNotFound) {
        let temp = this.$t("labels.ReVisitPropertyNotFoundDesc");
        temp = temp.replace("{0}", this.mainApplicant.Identification.FirstName);
        temp = temp.replace("{1}", this.app.InterView.strDownPaymentAmount);
        return temp;
      }
      if (this.isRefinance) {
        let temp = this.$t("labels.ReVisitRefinanceDesc");
        temp = temp.replace("{0}", this.mainApplicant.Identification.FirstName);
        temp = temp.replace("{1}", this.app.InterView.strClosingDateMMM);
        return temp;
      }
      if (this.isRenewal) {
        let temp = this.$t("labels.ReVisitRenewal");
        temp = temp.replace("{0}", this.mainApplicant.Identification.FirstName);
        temp = temp.replace("{1}", this.app.InterView.strClosingDateMMM);
        return temp;
      }
      if (this.isConstruction) {
        let temp = this.$t("labels.ReVisitConstruction");
        temp = temp.replace("{0}", this.mainApplicant.Identification.FirstName);
        temp = temp.replace(
          "{1}",
          this.app.RequestedMortgage.strRequestedMortgageAmount
        );
        temp = temp.replace("{2}", this.app.InterView.strClosingDateMMM);
        return temp;
      }
      return null;
    },
    requestedAmount() {
      return (
        this.app.InterView.PropertyValue - this.app.InterView.DownPaymentAmount
      );
    },
    mainApplicant() {
      if (this.app.RequestReview == true) {
        return this.app.Applicants[0];
      } else {
        for (let i = 0; i < this.app.Applicants.length; i++) {
          if (this.app.Applicants[i].Identification.PrimaryFlag === true)
            return this.app.Applicants[i];
        }
      }
      return null;
    },
    isOfferAccepted() {
      if (this.isPropertyFound && this.app.InterView.SearchStageDD == 1)
        return true;
      return false;
    },
    isPropertyFound() {
      if (this.app.InterView.DealPurposeDD == 0) {
        if (
          this.app.InterView.SearchStageDD >= 1 &&
          this.app.InterView.SearchStageDD <= 3
        ) {
          return true;
        }
      }
      return false;
    },
    isPropertyNotFound() {
      if (this.app.InterView.DealPurposeDD == 0) {
        if (
          this.app.InterView.SearchStageDD >= 4 &&
          this.app.InterView.SearchStageDD <= 5
        ) {
          return true;
        }
      }
      return false;
    },
    isRefinance() {
      if (this.app.InterView.DealPurposeDD == 2) return true;
      return false;
    },
    isRenewal() {
      if (this.app.InterView.DealPurposeDD == 4) return true;
      return false;
    },
    isConstruction() {
      if (this.app.InterView.DealPurposeDD == 3) return true;
      return false;
    },
  },
  data() {
    return {
      MortgageTypeItems: [
        {
          Label: this.$t('labels.Staying'), Value: 1
        },
        {
          Label: this.$t('labels.Replacing'), Value: 2
        },

      ],
      pv: null,
      dpJustChangeFlag: false,
      downpaymentData: {
        data: [],
        range: [],
      },
      sliderData: {
        data: [],
        range: [],
      },

      refinanceData: {
        data: [],
        range: [],
      },

      dpPercentage: null,
      frm: model.mortgageRequestModel(),
      loadFlag: false,
      app: model.appModel(),
      a: null,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false,
    };
  },
  methods: {
    deleteMortgage(mortgageID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteMortgage"),
        () => {
          if (mortgageID <= 0) {
            this.removeMortgage(mortgageID);
          } else {
            let postData = {
              SiteID: this.siteID,
              UserID: this.userID,
              MortgageApplicationID: this.mortgageApplicationID,

              MortgageID: mortgageID,
            };
            this.loadFlag = true;
            dataSvc
              .getHttp()
              .post("/api/MTGAPPDeleteMortgage", postData)
              .then((res) => {
                this.loadFlag = false;
                this.removeMortgage(mortgageID);
              });
          }
        },
        () => {}
      );
    },
    removeMortgage(mortgageID) {
      this.frm.SubjectProperty.Mortgages =
        this.frm.SubjectProperty.Mortgages.filter(
          (item) => item.MortgageID != mortgageID
        );
    },
    addMortgage() {
      let mtg = model.mortgageModel();
      mtg.MortgageID = 0 - this.frm.SubjectProperty.Mortgages.length;
      if(this.frm.SubjectProperty.Mortgages.length  == 0)
        mtg.MortgageTypeDD = 1;
      else
        mtg.MortgageTypeDD = 3;
      this.frm.SubjectProperty.Mortgages.push(mtg);
    },
    dpChange() {
      if (this.dpJustChangeFlag) return;
      this.app.InterView.DownPaymentAmount =
        (this.dpPercentage / 100) * this.app.InterView.PropertyValue;
    },
    pvChange() {
      this.app.InterView.DownPaymentAmount =
        (this.dpPercentage / 100) * this.app.InterView.PropertyValue;
    },
    next() {
      if (!this.valid()) return;

      this.frm.PropertyValue = this.app.InterView.PropertyValue;
      this.frm.DownPayment = this.app.InterView.DownPaymentAmount;

      let postData = {
        RequestMortgage: this.frm,
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        DwellingTypeDD: this.app.InterView.PropertyTypeDD,
      };
      if (this.isPropertyFound) postData.RequestTypeDD = 1;
      if (this.isPropertyNotFound) postData.RequestTypeDD = 2;
      if (this.isRefinance) postData.RequestTypeDD = 3;
      if (this.isRenewal) postData.RequestTypeDD = 4;
      if (this.isConstruction) postData.RequestTypeDD = 5;

      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPUpdateRequestMortgage", postData)
        .then((res) => {
          this.loadFlag = false;
          if (
            this.app.showRequestDocument == true &&
            this.app.RequestReview == false
          ) {
            this.$router.push(
              "/" +
                this.siteID +
                "/user/" +
                this.mortgageApplicationID +
                "/request"
            );
          } else if (
            this.app.showBankStatement == true &&
            this.app.RequestReview == false
          ) {
            this.$router.push(
              "/" +
                this.siteID +
                "/user/" +
                this.mortgageApplicationID +
                "/bankStatement"
            );
          } else {
            this.$router.push(
              "/" +
                this.siteID +
                "/user/" +
                this.mortgageApplicationID +
                "/summary"
            );
          }

          //to summary
        });
    },
    valid() {
      if (this.isPropertyFound) {
        if (this.app.InterView.DownPaymentAmount <= 0) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.InterViewMissingDownPayment")
          );
          return false;
        }
        if (this.app.InterView.PropertyValue <= 0) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.InterViewMissingPropertyValue")
          );
          return false;
        }
        if (
          this.app.InterView.PropertyValue -
            this.app.InterView.DownPaymentAmount <=
          0
        ) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.MissingRequiredMortgage")
          );
          return false;
        }
        if (
          !this.frm.SubjectProperty.Address.StreetName ||
          this.frm.SubjectProperty.Address.StreetName == ""
        ) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.MortgageMissingAddress")
          );
          return false;
        }
        if (
          this.app.InterView.SearchStageDD < 4 ||
          this.app.InterView.DealPurposeDD == 4 ||
          this.app.InterView.DealPurposeDD == 2 ||
          this.app.InterView.DealPurposeDD == 3
        ) {
          if (!this.frm.SubjectProperty.ClosingDate) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.InterViewMissingClosingDate")
            );
            return false;
          }
        }
      }
      if (this.isPropertyNotFound) {
        if (
          this.app.InterView.SearchStageDD < 4 ||
          this.app.InterView.DealPurposeDD == 4 ||
          this.app.InterView.DealPurposeDD == 2 ||
          this.app.InterView.DealPurposeDD == 3
        ) {
          if (!this.frm.SubjectProperty.ClosingDate) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.InterViewMissingClosingDate")
            );
            return false;
          }
        }

        if (this.frm.SubjectProperty.Address.ProvinceDD == null) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.MissingWhichProvince")
          );
          return false;
        }
      }
      if (this.isRenewal || this.isRenewal) {
        if (this.frm.SubjectProperty.Address.StreetName == "") {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.MortgageMissingAddress")
          );
          return false;
        }
        if (this.frm.SubjectProperty.EstimatedValue <= 0) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.MortgageMissingEstimatedValue")
          );
          return false;
        }
        for (let i = 0; i < this.frm.SubjectProperty.Mortgages.length; i++) {
          let mtg = this.frm.SubjectProperty.Mortgages[i];
          if (mtg.TotalLoanAmount <= 0) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.MortgageMissingOriginalMtgAmount")
            );
            return false;
          }
          if (!mtg.Balance || mtg.Balance <= 0) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.MortgageMissingBalance")
            );
            return false;
          }
          if (!mtg.PAndIPayment || mtg.PAndIPayment <= 0) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.MortgageMissingPayment")
            );
            return false;
          }
          if (mtg.PaymentFrequencyDD == null) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.MortgageMissingPaymentFrequency")
            );
            return false;
          }
          if (!mtg.MaturityDate) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.PropertyMissingMaturityDate")
            );
            return false;
          }
          if (!mtg.InterestRate || mtg.InterestRate <= 0) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.PropertyMissingInterestRate")
            );
            return false;
          }
          if (mtg.LoanTypeDD == null) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors.PropertyMissingLoanType")
            );
            return false;
          }
        }
      }
      if (this.isRefinance || this.isRefinance) {
        if (this.frm.SubjectProperty.EstimatedValue <= 0) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.MortgageMissingEstimatedValue")
          );
          return false;
        }
        if (this.app.InterView.PropertyTypeDD == null) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.PropertyMissingPropertyType")
          );
          return false;
        }
      }
      return true;
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;
            this.frm = res.data.RequestedMortgage;

            let pv = res.data.InterView.PropertyValue;
            let dp = res.data.InterView.DownPaymentAmount;

            if (this.isPropertyNotFound) {
              this.app.InterView.PropertyValue =
                res.data.InterView.DownPaymentAmount;
              this.dpPercentage = 100;
              pv = dp;
            } else {
              this.dpPercentage = Math.round((dp / pv) * 100);
            }

            setTimeout(() => {
              this.app.InterView.PropertyValue = pv;
              this.app.InterView.DownPaymentAmount = dp;
              this.pv = pv;
              this.frm.SubjectProperty.ClosingDate =
                this.app.InterView.ClosingDate.substr(0, 10);
            }, 500);

            for (
              let i = 0;
              i < this.frm.SubjectProperty.Mortgages.length;
              i++
            ) {
              setTimeout(() => {
                let temp = this.frm.SubjectProperty.Mortgages[i].MaturityDate;
                this.frm.SubjectProperty.Mortgages[i].MaturityDate = "1900-1-1";
                setTimeout(() => {
                  this.frm.SubjectProperty.Mortgages[i].MaturityDate =
                    temp.substr(0, 10);
                }, 200);
              }, 200);
            }
          }

          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }

    //https://github.com/biigpongsatorn/vue-slide-bar
    for (let i = 0; i <= 20; i++) {
      this.sliderData.data.push((5000000 / 20) * i);
    }
    this.sliderData.range.push({
      label: "0",
    });
    this.sliderData.range.push({
      label: "2,500K",
    });
    this.sliderData.range.push({
      label: "5,000K",
    });

    this.refinanceData.range.push({ label: "0" });
    this.refinanceData.range.push({ label: "500K" });
    this.refinanceData.range.push({ label: "1,000K" });

    for (let i = 0; i <= 20; i++) {
      this.downpaymentData.data.push(i * 5);
    }
    this.downpaymentData.range.push({ label: "0" });
    this.downpaymentData.range.push({ label: "50%" });
    this.downpaymentData.range.push({ label: "100%" });

    // this.requestedAmount= this.app.InterView.PropertyValue - this.app.InterView.DownPaymentAmount;
  },
  watch: {
    "app.InterView.DownPaymentAmount": {
      handler(n) {
        let newP = 0;
        try {
          newP = Math.round(
            (this.app.InterView.DownPaymentAmount /
              this.app.InterView.PropertyValue) *
              100
          );
        } catch (err) {
          console.error(err);
        }

        if (newP <= 100) {
          this.dpPercentage = newP;
          this.dpJustChangeFlag = true;
          setTimeout(() => {
            this.dpJustChangeFlag = false;
          }, 100);
        }
      },
      deep: false,
    },
  },
};
</script>
